module.exports = require("css-vars-ponyfill");